import { Dictionary } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { Partner } from './partner.model';
import { Prestation } from './prestation.model';

export interface PrestationItem {
    prestation: Prestation;
    name: Dictionary;
}

export interface ItemStock {
    item: PrestationItem;
    totalStock: number;
}

export class PrestationAvailability extends ApiData {
    prestation: Prestation;
    partner: Partner;
    startDate: Date;
    endDate: Date;
    itemsStock: ItemStock[];
}

